import { REQUEST_BOARD_CARD_NUMBER_PREFIX } from './RequestBoardCardHead.constants'

export function getRequestBoardCardNumber(requestNo) {
  return `${REQUEST_BOARD_CARD_NUMBER_PREFIX}${requestNo}`
}
